class SalespersonLookup {
  constructor() {
    this.searchInput = document.getElementById('salesperson-search');
    this.resultsCount = document.getElementById('results-count');
    this.resultsText = document.getElementById('results-text');
    this.totalCount = document.getElementById('total-count');
    this.searchStatus = document.getElementById('search-status');
    this.noResults = document.getElementById('no-results');
    this.clearSearchBtn = document.getElementById('clear-search');
    this.cards = document.querySelectorAll('.salesperson-card');
    this.totalCards = this.cards.length;
    
    this.init();
  }

  init() {
    if (!this.searchInput) return;
    
    // Add event listeners
    this.searchInput.addEventListener('input', this.debounce(this.handleSearch.bind(this), 300));
    this.searchInput.addEventListener('focus', this.handleSearchFocus.bind(this));
    this.searchInput.addEventListener('blur', this.handleSearchBlur.bind(this));
    
    // Clear search button
    if (this.clearSearchBtn) {
      this.clearSearchBtn.addEventListener('click', this.clearSearch.bind(this));
    }
    
    // Initial state
    this.updateResultsCount(this.totalCards);
    this.setInitialInstructions();
  }

  setInitialInstructions() {
    if (this.searchStatus) {
      this.searchStatus.style.display = 'none';
    }
  }

  handleSearchFocus() {
    this.searchInput.parentElement.classList.add('search-field--focused');
  }

  handleSearchBlur() {
    this.searchInput.parentElement.classList.remove('search-field--focused');
  }

  handleSearch(event) {
    const searchTerm = event.target.value.toLowerCase().trim();
    
    if (searchTerm === '') {
      this.showAllCards();
      this.showInitialStatus();
      return;
    }
    
    this.filterCards(searchTerm);
    this.showSearchStatus(searchTerm);
  }

  filterCards(searchTerm) {
    let visibleCount = 0;
    
    this.cards.forEach(card => {
      const name = card.dataset.name || '';
      const email = card.dataset.email || '';
      const zipcodes = card.dataset.zipcodes || '';
      
      const isMatch = 
        name.includes(searchTerm) ||
        email.includes(searchTerm) ||
        zipcodes.includes(searchTerm) ||
        this.matchesZipcode(zipcodes, searchTerm);
      
      if (isMatch) {
        card.classList.remove('hidden');
        visibleCount++;
      } else {
        card.classList.add('hidden');
      }
    });
    
    this.updateResultsCount(visibleCount);
    this.toggleNoResults(visibleCount === 0);
  }

  matchesZipcode(zipcodeString, searchTerm) {
    if (!zipcodeString || !searchTerm) return false;
    
    const zipcodes = zipcodeString.split(/[,\s]+/).filter(zip => zip.length > 0);
    
    return zipcodes.some(zipcode => {
      return zipcode.startsWith(searchTerm) || zipcode.includes(searchTerm);
    });
  }

  showAllCards() {
    this.cards.forEach(card => {
      card.classList.remove('hidden');
    });
    
    this.updateResultsCount(this.totalCards);
    this.toggleNoResults(false);
  }

  updateResultsCount(count) {
    if (this.resultsCount) {
      this.resultsCount.textContent = count;
    }
    
    if (this.resultsText) {
      this.resultsText.textContent = count === 1 ? 'salesperson' : 'salespeople';
    }

    if (this.totalCount) {
      this.totalCount.textContent = this.totalCards;
    }
  }

  showInitialStatus() {
    if (this.searchStatus) {
      this.searchStatus.style.display = 'none';
      this.searchStatus.textContent = '';
    }
  }

  showSearchStatus(searchTerm) {
    if (this.searchStatus) {
      const visibleCount = document.querySelectorAll('.salesperson-card:not(.hidden)').length;
      
      if (visibleCount > 0) {
        this.searchStatus.textContent = `Filtered by "${searchTerm}"`;
        this.searchStatus.style.display = 'inline';
        this.searchStatus.style.color = '#059669';
      } else {
        this.searchStatus.style.display = 'none';
      }
    }
  }

  toggleNoResults(show) {
    if (this.noResults) {
      this.noResults.style.display = show ? 'block' : 'none';
    }
    
    if (show && this.searchStatus) {
      this.searchStatus.textContent = 'No matches found';
      this.searchStatus.style.display = 'inline';
      this.searchStatus.style.color = '#dc2626';
    }
  }

  clearSearch() {
    if (this.searchInput) {
      this.searchInput.value = '';
      this.showAllCards();
      this.showInitialStatus();
      this.searchInput.focus();
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SalespersonLookup();
});

if (typeof window.initializeSalespersonLookup === 'undefined') {
  window.initializeSalespersonLookup = () => {
    new SalespersonLookup();
  };
}